import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommerceRefundsEntityState} from "../reducers/ecommerce-refunds.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommerceRefundsState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommerceRefunds.entities[websiteId]);

export const getEcommerceRefunds = (websiteId: number, orderId: number) => createSelector(getEcommerceRefundsState(websiteId),
  (state: IEcommerceRefundsEntityState) => {
    return state?.data ? state.data : [];
  }
);

export const getEcommerceRefundsLoading = (websiteId: number) => createSelector(getEcommerceRefundsState(websiteId),
  (state: IEcommerceRefundsEntityState) => state && state.loading
);

export const getEcommerceRefundsLoaded = (websiteId: number) => createSelector(getEcommerceRefundsState(websiteId),
  (state: IEcommerceRefundsEntityState) => state && state.loaded
);
